import { GenericAlarmFormat } from '../generic-alarm-format';
import { isArray } from 'util';

export class GenericAlarmFormatBuilder {
  static fromJson(json) {
    return (json)
      ? new GenericAlarmFormat(
        json.code,
        json.name
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(GenericAlarmFormatBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/generic-alarm-format.builder.ts